"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Error = function Error() {
  return _react2.default.createElement(
    "g",
    { id: "error" },
    _react2.default.createElement("path", {
      d: "M225.508982,325 L275.409182,325 L275.409182,375 L225.508982,375 L225.508982,325 Z M225.508982,125 L275.409182,125 L275.409182,275 L225.508982,275 L225.508982,125 Z M250.209581,1.36557432e-14 C112.52495,0 0.958083832,112 0.958083832,250 C0.958083832,388 112.48503,500 250.209581,500 C388.183633,500 499.96008,388 499.96008,250 C499.96008,112 388.183633,0 250.249501,0 L250.209581,1.36557432e-14 Z M250.459082,450 C140.222605,450 50.8582834,360.45695 50.8582834,250 C50.8582834,139.54305 140.222605,50 250.459082,50 C360.695559,50 450.05988,139.54305 450.05988,250 C450.07577,303.048177 429.051563,353.928211 391.615707,391.438939 C354.179852,428.949666 303.401375,450.015922 250.459082,450 L250.459082,450 Z",
      id: "Shape"
    })
  );
};

exports.default = Error;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Error.js
// module id = 2944
// module chunks = 4